import { render } from "./YouthModePrompt.vue?vue&type=template&id=7f70dac0&scoped=true"
import script from "./YouthModePrompt.vue?vue&type=script&lang=js"
export * from "./YouthModePrompt.vue?vue&type=script&lang=js"

import "./YouthModePrompt.vue?vue&type=style&index=0&id=7f70dac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f70dac0"]])

export default __exports__